/**
 * EVO — ro'yxat ekranlarining URL holati.
 *
 * ============================================================================
 * NIMA UCHUN URL DA, KOMPONENT HOLATIDA EMAS
 * ============================================================================
 *   • havola ulashiladi: «3-sahifa, tannarx bo'yicha» hamkasbga yuboriladi va
 *     u AYNAN o'sha ekranni ochadi;
 *   • kartochkadan «Orqaga» bosilganda ro'yxat o'z holatida qaytadi;
 *   • brauzerning «orqaga» tugmasi kutilganidek ishlaydi.
 *
 * Barcha maydonlar IXTIYORIY: `<Link to="/products">` qo'shimcha parametrsiz
 * ishlashi kerak, va `?page=1&sortDir=asc` ni URL da yozib yurishning ma'nosi
 * yo'q — default qiymat ekranda baribir o'sha.
 *
 * Default'lar YAGONA joyda (`resolveListSearch`): har ekranda `search.page ?? 1`
 * yozilsa, bitta unutilgan joy ro'yxatni jimgina 1-sahifaga qaytarib yuboradi.
 */
import type { SortDir } from './products';

export interface ListSearch {
  readonly page?: number;
  readonly sortBy?: string;
  readonly sortDir?: SortDir;
  readonly q?: string;
}

export interface ResolvedListSearch {
  readonly page: number;
  readonly sortBy: string | undefined;
  readonly sortDir: SortDir;
  readonly q: string | undefined;
}

export function resolveListSearch(search: ListSearch): ResolvedListSearch {
  return {
    page: search.page ?? 1,
    sortBy: search.sortBy,
    sortDir: search.sortDir ?? 'asc',
    q: search.q,
  };
}

/**
 * URL uchun toza parametr to'plami: default qiymatlar TUSHIRIB QOLDIRILADI.
 *
 * `?page=1&sortDir=asc&q=` ko'rinishidagi manzil uzun va ko'chirib yuborishga
 * noqulay; bundan tashqari «bu yerda nimadir sozlangan» degan noto'g'ri
 * taassurot beradi.
 */
export function toListSearchParams(next: ResolvedListSearch): ListSearch {
  return {
    ...(next.page > 1 ? { page: next.page } : {}),
    ...(next.sortBy ? { sortBy: next.sortBy } : {}),
    ...(next.sortDir === 'desc' ? { sortDir: 'desc' as SortDir } : {}),
    ...(next.q ? { q: next.q } : {}),
  };
}

/** URL dan kelgan xom qiymatlarni tozalaydi — foydalanuvchi manzilni qo'lda tahrirlashi mumkin. */
export function parseListSearch(search: Record<string, unknown>): ListSearch {
  const page = Number(search.page);

  return toListSearchParams({
    // `Number.isInteger` — `1.5` va `NaN` ikkalasini ham rad etadi.
    page: Number.isInteger(page) && page > 1 ? page : 1,
    /*
     * `sortBy` oq ro'yxatga solishtirilmaydi va bu ongli qaror: yagona haqiqiy
     * ro'yxat SERVERDA (`PRODUCT_SORTABLE` + `PROTECTED_FIELDS` tekshiruvi).
     * Uni brauzerda takrorlasak, ikkita nusxa paydo bo'ladi va ular vaqt o'tib
     * bir-biridan farq qiladi. Noto'g'ri maydon serverdan 400 qaytaradi va
     * jadval xato holatini ko'rsatadi — bu to'g'ri xulq.
     */
    sortBy: typeof search.sortBy === 'string' && search.sortBy !== '' ? search.sortBy : undefined,
    sortDir: search.sortDir === 'desc' ? 'desc' : 'asc',
    q: typeof search.q === 'string' && search.q !== '' ? search.q : undefined,
  });
}
